import { binarySearchRange3kxkkwuchjxxl as binarySearchRange } from './_DigitChars.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function isOtherLowercase(_this__u8e3s4) {
  var index = binarySearchRange(OtherLowercase_getInstance().otherLowerStart_1, _this__u8e3s4);
  return index >= 0 && _this__u8e3s4 < (OtherLowercase_getInstance().otherLowerStart_1[index] + OtherLowercase_getInstance().otherLowerLength_1[index] | 0);
}
var OtherLowercaseClass;
function OtherLowercase() {
  if (OtherLowercaseClass === VOID) {
    class $ {
      constructor() {
        OtherLowercase_instance = this;
        var tmp = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp.otherLowerStart_1 = new Int32Array([170, 186, 688, 704, 736, 837, 890, 7468, 7544, 7579, 8305, 8319, 8336, 8560, 9424, 11388, 42652, 42864, 43000, 43868]);
        var tmp_0 = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp_0.otherLowerLength_1 = new Int32Array([1, 1, 9, 2, 5, 1, 1, 63, 1, 37, 1, 1, 13, 16, 26, 2, 2, 1, 2, 4]);
      }
    }
    initMetadataForObject($, 'OtherLowercase');
    OtherLowercaseClass = $;
  }
  return OtherLowercaseClass;
}
var OtherLowercase_instance;
function OtherLowercase_getInstance() {
  if (OtherLowercase_instance === VOID)
    new (OtherLowercase())();
  return OtherLowercase_instance;
}
//region block: exports
export {
  isOtherLowercase as isOtherLowercase4q2d1aggqu6,
};
//endregion

//# sourceMappingURL=_OtherLowercaseChars.mjs.map
